module.exports = __webpack_public_path__ + "static/media/country_vi.7c061e37.webp";